import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "flag-name" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "form-check form-switch" }
const _hoisted_8 = ["onChange", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedDefinitions, (category, index) => {
    return (_openBlock(), _createElementBlock("div", { key: index }, [
      _createElementVNode("h4", null, _toDisplayString(category[0]), 1),
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category[1], (config, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-sm-6 col-md-4",
            key: index
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(config.Name), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("input", {
                    class: "form-check-input form-switch-lg",
                    type: "checkbox",
                    onChange: ($event: any) => (_ctx.handleStateChanged(config.Id)),
                    checked: _ctx.configurations.get(config.Id)
                  }, null, 40, _hoisted_8)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ]))
  }), 128))
}